// ===================== MUI Icons =====================
import PhoneIcon from "@mui/icons-material/Phone";
import InstagramIcon from "@mui/icons-material/Instagram";
import CategoryIcon from "@mui/icons-material/Category";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import LockIcon from "@mui/icons-material/Lock";
import GroupIcon from "@mui/icons-material/Group";
import GroupsIcon from "@mui/icons-material/Groups";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PeopleIcon from "@mui/icons-material/People";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MapIcon from "@mui/icons-material/Map";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import TerrainIcon from "@mui/icons-material/Terrain";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BusinessIcon from "@mui/icons-material/Business";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TemplateIcon from "@mui/icons-material/AutoAwesomeMosaic";
import CreateIcon from "@mui/icons-material/Create";
import CampaignIcon from "@mui/icons-material/Campaign";
import Groups2Icon from "@mui/icons-material/Groups2";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MessageIcon from "@mui/icons-material/Message";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import ArticleIcon from "@mui/icons-material/Article";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PaidIcon from "@mui/icons-material/Paid";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HandymanIcon from "@mui/icons-material/Handyman";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import InsightsIcon from "@mui/icons-material/Insights";
import ContactsIcon from "@mui/icons-material/Contacts";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DescriptionIcon from "@mui/icons-material/Description";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PaymentsIcon from "@mui/icons-material/Payments";
import GridViewIcon from "@mui/icons-material/GridView";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DoorFrontIcon from "@mui/icons-material/DoorFront";
import AccountBalanceWalletTwoToneIcon from "@mui/icons-material/AccountBalanceWalletTwoTone";
import PaymentsTwoToneIcon from "@mui/icons-material/PaymentsTwoTone";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import AddchartTwoToneIcon from "@mui/icons-material/AddchartTwoTone";
import ShoppingCartTwoToneIcon from "@mui/icons-material/ShoppingCartTwoTone";
import HouseIcon from "@mui/icons-material/House";
import AddHomeWorkRoundedIcon from "@mui/icons-material/AddHomeWorkRounded";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import React from "react";
import {
  FilterAlt,
  PlaylistAdd,
  Menu,
  PieChart,
  Timeline,
  Upload,
  ChatBubble,
  People,
  Quiz,
  Assistant,
  Report,
  Analytics,
  AccountTree,
  Assignment,
} from "@mui/icons-material";

// ===================== MUI Core =====================
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  useMediaQuery,
} from "@mui/material";
import IcecreamIcon from "@mui/icons-material/Icecream";
import SummarizeIcon from "@mui/icons-material/Summarize";

// ===================== React =====================
import { useCallback } from "react";

// ===================== Hooks =====================
import { useAuth } from "../../hooks/AuthProvider";

// ===================== Pages / Components =====================
import Home from "./../Home";
import CustomerHomePage from "./../Customers/CustomersHome";
import UploadHistory from "./../UploadHistory";
import BlankTab from "./../BlankTab";
import CustomersTab from "./../OasisCustomers/CustomersTab";
import DriversTab from "./../drivers/DriversTab";
import OrdersTab from "./../orders/OrdersTab";
import MagentoOrdersTab from "./../Magento/MagentoOrdersTab";
import RCSCampaignAnalyticsTab from "./../RCSCampaignAnalytics/RCSCampaignAnalyticsTab";
import RCSAnalyticsTab from "./../RCSCampaignAnalytics/RCSAnalyticsTab";
import DriverOrderReportTab from "./../reports/drivers/DriverOrderReportTab";
import ZoneOrderReportTab from "./../reports/zones/ZoneOrderReportTab";
import CustomerOrderReportTab from "./../reports/customers/CustomerOrderReportTab";
import MonthlyPerformanceReportTab from "./../reports/graphs/MonthlyPerformanceReportTab";
import TimeSlotWiseReportTab from "./../reports/graphs/TimeSlotWiseReportTab";
import UsersTab from "./../users/UsersTab";
import JobsTab from "./../jobs/JobsTab";
import ZonesTab from "./../zones/ZonesTab";
import ZoneAssignmentsTab from "./../zones/ZonesAssignmentTab";
import ChatDashboard from "./../ChatDashboard";
import ChatHistoryDashboard from "./../ChatHistoryDashboard";
import Whatsapp from "./../Whatsapp/Whatsapp";
import CreateTemplateManual from "./../Whatsapp/CreateTemplateManual";
import ComingSoonPage from "./../ComingSoon/ComingSoonPage";
import Header from "./../Header";
import Footer from "./../Footer";
import WhatsAppMessage from "./../WhatsAppMessage";
import MarketingLogsTable from "./../MarketingLogs/MarketingLogs";
import ErrorLogsTable from "./../ErrorLogs";
import Broadcast from "./../BroadcastTemplates/Broadcast";
import BroadcastAudienceTab from "./../Audience/BroadcastAudienceTab";
import Campaigns from "./../Campaigns/Campaigns";
import AppUsage from "./../AppUsage/AppUsage";
import MetaCard from "./../MetaCard/MetaCard";
import GenerateQR from "./../GenerateQR/GenerateQR";
import SettingsDashboard from "./../SettingsDashboard/SettingsDashboard";
import NoAccessPage from "./../NoAccessPage";
import Products from "./../Products/Products";
import Orders from "./../OrderItem/Orders";
import ClientDetails from "./../ClientDetails/ClientDetails";
import RMDashboard from "./../RMDashboard/RMDashboard";
import RMMetricsDashboard from "./../SuperRMDashboard/RMMetricsDashboard";
import SyncKRClientLog from "./../SyncKRClientLogs";
import CustomerMsgDashboard from "./../CustomerMsgDashboard";
import UserEngagementOverview from "./../UserEngagementOverview/UserEngagementOverview";
import BroadcastCampaigns from "./../CampaignManagement/BroadcastCampaigns";
import CampaignsV2 from "./../CampaignsV2/CampaignsV2";
import CampaignSetup from "./../CampaignsV2/CampaignSetup";
import ConversationPanel from "./../ConversationalAI/ConversationPanel";
import FileUploadLogs from "./../FileUploadLogs/FileUploadLogs";
import TemplateAnalytics from "./../TemplateAnalytics/TemplateAnalytics";
import TenantOnboardingPage from "./../Onboarding/TenantOnboardingPage";
import AppointmentManagement from "./../AppointmentManagement/AppointmentManagement";
import Voice from "./../Voice/Voice";
import InvoiceBilling from "./../InvoiceBilling/InvoiceBilling";
import MyWallet from "./../MyWallet/MyWallet";
import CalendlyBooking from "./../CalendlyBooking/CalendlyBooking";
import Zoho from "./../Zoho/Zoho";
import IntegrationsOverview from "./../IntegrationsOverview/IntegrationsOverview";
import DoorLocksTab from "./../DormakabaDashboard/DoorLocksTab";
import InstallationTab from "./../DormakabaDashboard/InstallationTab";
import ServiceTab from "./../DormakabaDashboard/ServiceTab";
import SalesTab from "./../DormakabaDashboard/SalesTab";
import TicketsTab from "./../DormakabaDashboard/TicketsTab";
import BotbridgeAnalytics from "./../UserEngagementOverview/BotbridgeAnalytics";
import Dashboard from "./../Dashboard/Dashboard";
import BillingDashboard from "./../BillingDashboard/BillingDashboard";
import CreateSegment from "./../Segment/CreateSegment";
import Segments from "./../Segment/Segments";
import UpdateSegment from "./../Segment/UpdateSegment";
import DripMarketing from "./../DripMarketing/DripMarketing";
import CreateDripMarketingCampaign from "./../DripMarketing/CreateDripMarketingCampaign";
import ChatAnalytics from "./../ChatAnalytics/ChatAnalytics.js";
import WhatsAppAnalyticsTab from "./../WhatsAppAnalytics/WhatsAppAnalyticsTab";
import DripMarketingCampaignDetails from "./../DripMarketing/DripMarketingCampaignDetails";
import PanchangUI from "./../KalnirnayDashboard/UploadData";
import PanchangLayout from "./../KalnirnayDashboard/PanchangLayout";


import OrderItemsList from "./../OrderItem/OrderItemsList";
import KalnirnayCustomers from "./../OrderItem/KalnirnayCustomers";
import QuizDashboardMUI from "./../OtmQuiz/QuizDashboard";
import RCSDashboardNew from "./../Rcs/RCSDashboard";
import ChannelOnboarding from "./../ChannelOnboarding/ChannelOnboarding";
import RCSBroadcastLogs from "./../Rcs_logs/RCSBroadcastLogsTable.js";
import ClimatronicsLeads from "../Climatronics/Leads.js";
import SubscriptionManagement from "../SubscriptionManagement/SubscriptionManagement";
import ClimatronicsCustomers from "../Climatronics/Customers.js";
import ClimatronicsOrders from "../Climatronics/Orders.js";
import MessageRatesDashboard from '../BillingDashboard/MessageRatesDashboard.js';

// New icons
import { ReactComponent as AudienceIconSVG } from "../../assets/images/icons/new_sidebar/customers.svg";
import { ReactComponent as KalanjayDanceAcademySVG } from "../../assets/images/icons/new_sidebar/kalanjay_final_fixed.svg";
import { ReactComponent as WhatsappChannel } from "../../assets/images/icons/sidebar/wa_channels.svg";
import { ReactComponent as WhatsappMarketing } from "../../assets/images/icons/new_sidebar/campaign.svg";
import { ReactComponent as WhatsappChat } from "../../assets/images/icons/new_sidebar/chat.svg";
import { ReactComponent as WhatsappAnalytics } from "../../assets/images/icons/sidebar/wa_analytics.svg";
import { ReactComponent as Billing } from "../../assets/images/icons/new_sidebar/billing.svg";
import { ReactComponent as Settings } from "../../assets/images/icons/sidebar/settings.svg";
import { ReactComponent as Logs } from "../../assets/images/icons/new_sidebar/logs.svg";
import { ReactComponent as Integrations } from "../../assets/images/icons/sidebar/integrations.svg";
import AIBotConfiguration from "../AIBotConfiguration";
import AIBotReport from "../Dashboard/AIBotReport/AIBotReport";
import Buyers from "../OrderItem/Buyers";
import ChatbotFlow from "../ChatbotFlow/ChatbotFlow";
import ViewForms from "../Forms/ViewForms";
import CreateForm from "../Forms/CreateForm";
import FormSubmissions from "../Forms/FormSubmissions";
import FormBuilder from "../Forms/Builder/FormBuilder";
import UnmatchedReplies from "../Forms/UnmatchedReplies";

import { ReactComponent as DashboardIconSVG } from "../../assets/images/icons/new_sidebar/dashboard.svg";
import { ReactComponent as ChatIconSVG } from "../../assets/images/icons/new_sidebar/chat.svg";
import { ReactComponent as WhatsappCommerce } from "../../assets/images/icons/new_sidebar/commerce.svg";

import { ReactComponent as LinkIcon } from "../../assets/images/icons/new_sidebar/rcs_bot.svg";
import { ReactComponent as AgenticAIIcon } from "../../assets/images/icons/new_sidebar/agentic_ai.svg";
import { ReactComponent as ChatbotConfigIcon } from "../../assets/images/icons/new_sidebar/chatbot_config.svg";
import { ReactComponent as WabaOnboardingIcon } from "../../assets/images/icons/new_sidebar/waba_onboarding.svg";
import { ReactComponent as ChannelsIcon } from "../../assets/images/icons/new_sidebar/channels.svg";
import { ReactComponent as MessageTemplateIcon } from "../../assets/images/icons/new_sidebar/message_template.svg";
import { ReactComponent as IntegrationIcon } from "../../assets/images/icons/new_sidebar/integration.svg";
import { ReactComponent as BussinessProfileIcon } from "../../assets/images/icons/new_sidebar/bussiness_profile.svg";
import { ReactComponent as UsersIcon } from "../../assets/images/icons/new_sidebar/customers.svg";
import { ReactComponent as ToolsIcon } from "../../assets/images/icons/new_sidebar/tools.svg";
import { ReactComponent as DepartmentsIcon } from "../../assets/images/icons/new_sidebar/departments.svg";
import { ReactComponent as AuditTrailIcon } from "../../assets/images/icons/new_sidebar/audit_trial.svg";
import { ReactComponent as RolePerIcon } from "../../assets/images/icons/new_sidebar/role_permission.svg";
import { ReactComponent as RCSChatIcon } from "../../assets/images/icons/new_sidebar/rcs-chat-icon.svg";


import WhatsAppVoiceSettings from "../Voice/WhatsAppVoiceSettings.js";
import InstagramFlow from "../InstagramFlow/InstagramFlow.js";
import AgenticAISkills from "../AgenticAI/AgenticAISkills.jsx";
import OverviewTab from "../BillingDashboard/OverviewTab.js";
import UsageCharges from "../BillingDashboard/UsageCharges.jsx";
import WalletTab from "../BillingDashboard/WalletTab.js";
import RateCardTab from "../BillingDashboard/RateCardTab.js";
import InvoicesTab from "../BillingDashboard/InvoicesTab.js";
import SettingsTab from "../BillingDashboard/SettingsTab.js";
import AITokenCalculator from "../GenerateQR/AITokenCalculator.js";
import KnowledgeBasePage from "../AgenticAI/KnowledgeBasePage.jsx";
import groupBy from "country-codes-list/dist/utils/groupBy.js";
import ChatbotStartPoint from "../ChatbotConfig/ChatbotStartPoint.jsx";
import Departments from "../Departments/Departments.jsx";
import AuditLogs from "../AuditTrail/AuditTrail.jsx";
import RolesAndPermissions from "../RolesPermissions/RolesPermissions.jsx";
import Workflows from "../ChatbotFlow/WorkFlow.js";
// import LeadGeneration from "../LeadGeneration/LeadGeneration.js";
import CustomerLeads from "../CustomerLeads/CustomerLeads.js";
import CustomerAccounts from "../CustomerAccounts/CustomerAccounts.js";
import UserFormPage from "../users/UserFormDialog.js";
import FormsManagement from "../Forms/FormIndex.js";
import LogsDashboard from "../Logs/Logs.jsx";
import FileUpload from "../Carepms/FileUpload.js";
import CTWADashboard from "../CTWA/CTWADashboard.js";
import Kalanjay from "../Kalanjay/Kalanjay.jsx";
import SipTrackingScreen from "../SipReminder/SipTrackingScreen.js";
import MutualFundDistributorDashboard from "../MutualFundDistributor/Dashboard.js";
import MutualFundDistributorLeads from "../MutualFundDistributor/Leads.js";
import MutualFundDistributorClients from "../MutualFundDistributor/Clients.js";
import MutualFundDistributorDailyHoldings from "../MutualFundDistributor/DailyHoldings.js";
import MutualFundDistributorRequests from "../MutualFundDistributor/Requests.js";
import MutualFundDistributorGoalPlans from "../MutualFundDistributor/GoalPlans.js";
import MutualFundDistributorFileUpload from "../MutualFundDistributor/FileUpload.js";
import MutualFundDistributorFileUploadLogs from "../MutualFundDistributor/FileUploadLogs.js";
import InsuranceReminderScreen from "../InsuranceReminder/InsuranceReminderScreen.js";
import EMIReminderScreen from "../EMIReminder/EMIReminderScreen.js";
import PharmacyDashboard from "../Pharmacy/PharmacyDashboard.js";
import BotBridgeLeads from "../BotBridge/Leads.js";
import CampaignAnalyticsPage from "../CTWA/CampaignAnalyticsPage.jsx";
import SurveyResponsesPage from "../SurveyReports/SurveyResponsesPage.js";
const tenant = localStorage.getItem("tenant");

// Add this helper function
const withBlackColor = (IconComponent) => (props) => (
  <IconComponent {...props} sx={{ color: "#232323" }} />
);

export const sidebarSections = {
  quiz: {
    title: "Quiz",
    icon: withBlackColor(Quiz),
    app: "onetouchindiamarketinglive",
  },
  kalnirnay: {
    title: "Kalnirnay",
    icon: withBlackColor(CloudUploadIcon),
    app: "kalnirnay",
  },
  main: {
    title: "Oasis Main",
    icon: withBlackColor(IcecreamIcon),
    app: "main",
  },
  magento: {
    title: "Magento",
    icon: withBlackColor(ReceiptLongIcon),
    app: "magento",
  },
  kalanjay: {
    title: "Kalanjay",
    icon: (props) => <KalanjayDanceAcademySVG style={{
      width: 24,
      height: 24,
      color: "#232323",
      transform: "scale(1.4)",   // 👈 increase size
      transformOrigin: "center"
    }} />,
    app: "kalanjay",
    component: Kalanjay,
  },
  reports: {
    title: "Oasis Reports",
    icon: withBlackColor(SummarizeIcon),
    app: "reports",
  },
  survey_reports: {
    title: "Survey Reports",
    icon: withBlackColor(SummarizeIcon),
    app: "survey_reports",
  },
  doorSolutions: {
    title: "Door Solutions",
    icon: withBlackColor(DoorFrontIcon),
    app: "door_solutions",
  },
  finance360: {
    title: "Finance 360",
    icon: withBlackColor(PaymentsTwoToneIcon),
    app: "finance360",
  },
  appointmentSystem: {
    title: "Appointment System",
    icon: DashboardIconSVG,
    app: "appointment_system",
  },
  voice: {
    title: "Voice Calls",
    icon: withBlackColor(RecordVoiceOverIcon),
    app: "voice",
  },
  climatronics: {
    title: "climatronics",
    icon: DashboardIconSVG,
    app: "climatronics",
  },
  mutual_fund_distributor: {
    title: "Mutual Fund Distributor",
    icon: DashboardIconSVG,
    app: "mutual_fund_distributor"
  },
  cent_bank: {
    title: "Cent Bank",
    icon: withBlackColor(PaymentsIcon),
    app: "cent_bank",
  },
  pharmacy: {
    title: "Pharmacy Data",
    icon: withBlackColor(CloudUploadIcon),
    app: "pharmacy",
  },
  botbridge: {
    title: "botbridge",
    icon: DashboardIconSVG,
    app: "botbridge"
  },
  // finance360: { title: "Finance 360", icon: <AccountBalanceWalletTwoToneIcon />, app: "finance360" },
  // finance360: { title: "Finance 360", icon: <CandlestickChartIcon />, app: "finance360" },
  dashboard: {
    title: "Dashboard",
    icon: DashboardIconSVG,
    app: "dashboard",
    component: Dashboard,
    id: "dashboard",
    tenant: [],
    roles: [],
    permission: "dashboard.view",
    feature: null,
  },

  whatsappChat: { title: "Chat", icon: WhatsappChat, app: "chat" },
  whatsappCampaign: {
    title: "Campaigns",
    icon: WhatsappMarketing,
    app: "campaigns",
  },
  analyticsMenu: {
    title: "Analytics",
    icon: (props) => <AssessmentIcon {...props} style={{ color: "#232323", fill: "#232323" }} />,
    app: "analyticsMenu",
  },
  commerce: {
    title: "Commerce",
    icon: WhatsappCommerce,
    app: "commerce",
  },
  customers: { title: "Contacts", icon: AudienceIconSVG, app: "customers" },
  billing: {
    title: "Billing",
    icon: Billing,
    app: "billing",
  },
  logs: { title: "Logs", icon: Logs, app: "logs" },

  agentic_ai: {
    title: "Agentic AI",
    icon: AgenticAIIcon,
    app: "agentic_ai",
  },
  chatbot_configuration: {
    title: "Chatbot Configurations",
    icon: ChatbotConfigIcon,
    app: "chatbot_configuration",
  },

  // lead_generation: {
  //   title: "Lead Generation",
  //   icon: (props) => <ContactsIcon {...props} style={{ color: "#232323", fill: "#232323" }} />,
  //   app: "lead_generation",    
  // },

  channels: {
    title: "Channels",
    icon: ChannelsIcon,
    app: "channels",
  },

  waba_onboarding: {
    title: "Channel Onboarding",
    icon: WabaOnboardingIcon,
    app: "waba_onboarding",
    component: ChannelOnboarding,
  },
  message_template: {
    title: "Message Template",
    icon: MessageTemplateIcon,
    app: "message_template",
  },

  integration: {
    title: "Integration",
    icon: IntegrationIcon,
    app: "integration",
  },
  whatsapp_voice_config: {
    title: "WhatsApp Voice",
    // No dedicated custom SVG exists under assets/images/icons/new_sidebar/
    // for voice/phone — using MUI's PhoneIcon instead (same icon
    // ChatList.js/CallActivityCard.js already use for "has a call"
    // elsewhere in the app). The custom SVG siblings here all hardcode
    // stroke="#232323" (never respond to SidebarButton.jsx's
    // isActive-driven `color: primary.main`, since they don't use
    // currentColor) — MUI icons DO inherit that color and turned blue
    // when this row was active, so the color is forced to match here,
    // keeping it visually consistent with every other row regardless of
    // active state.
    icon: () => <PhoneIcon sx={{ color: "#232323" }} />,
    // Must be the AppModule codename ("voice", from tenant/constants.py's
    // BASE_APP_MODULES), not the Feature codename — Sidebar.js's
    // `userApps.includes(value.app)` gate checks against `apps`
    // (AppModule codenames from api/views.py's get_app_modules(), via
    // PlanFeature), a separate gate from `permission` (checked against
    // `userPermissions`, GroupFeaturePermission-derived). Easy to miss
    // because bussiness_profile's app-module and feature codenames are
    // both "bussiness_profile" — this genuinely differs when they're not
    // the same string, and it silently hides the entry with no console
    // error when wrong.
    app: "voice",
    component: WhatsAppVoiceSettings,
    id: "whatsapp_voice_config_direct",
    tenant: [],
    roles: [],
    permission: "whatsapp_voice_config.view",
    feature: null,
  },
  instagram_flow: {
    title: "Instagram Flow",
    // Same forced color as whatsapp_voice_config's MUI icon (see the note there).
    icon: () => <InstagramIcon sx={{ color: "#232323" }} />,
    // ponytail: rides on the chatbot_configuration app module and the existing
    // work_flow.view permission; add an "instagram" AppModule + Feature when it
    // needs plan gating of its own.
    app: "chatbot_configuration",
    component: InstagramFlow,
    id: "instagram_flow_direct",
    tenant: [],
    roles: [],
    permission: "work_flow.view",
    feature: null,
  },
  bussiness_profile: {
    title: "Business Profile",
    icon: BussinessProfileIcon,
    app: "bussiness_profile",
    component: SettingsDashboard,
    id: "bussiness_profile_direct",
    tenant: [],
    roles: [],
    permission: "bussiness_profile.view",
    feature: null,
  },

  users: {
    title: "Users",
    icon: UsersIcon,
    app: "users",
    component: UsersTab,
    id: "users",
    tenant: [],
    roles: ["admin"],
    permission: "users.view",
    feature: "users",
  },

  tools: {
    title: "Tools",
    icon: ToolsIcon,
    app: "tools",
    component: GenerateQR,
    id: "tools",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "tools.view",
    feature: null,
  },
  departments: {
    title: "Departments",
    icon: DepartmentsIcon,
    app: "departments",
    component: Departments,
    id: "departments",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "departments.view",
    feature: null,
  },
  audit_trial: {
    title: "Audit Trail",
    icon: AuditTrailIcon,
    app: "audit_trial",
    component: AuditLogs,
    id: "audit_trial",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "audit_trial.view",
    feature: null,
  },
  role_permission: {
    title: "Role & Permission",
    icon: RolePerIcon,
    app: "role_permission",
    component: RolesAndPermissions,
    id: "role_permission",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "role_permission.view",
    feature: null,
  },
  logs: {
    title: "Logs",
    icon: Logs,
    app: "logs",
    component: LogsDashboard ,
    permission: "logs.view",
  },
  rcs_bot_create: {
    title: "RCS Bot Create",
    component: RCSDashboardNew ,
    icon: RCSChatIcon,
    app: "rcs_bot_create",
    permission: "rcs_bot_create.view"
  },
  ctwa: {
    title: "CTWA",
    icon: IntegrationIcon,
    app: "ctwa",
  }
};

export const sideBarData = {
  //  "chat-bot":{
  //   title: "Chat",
  //   id: "chat-bot",
  //   component: (props) => <ChatIcon {...props} />,
  //   icon: <ChatIcon />,
  //   app: "main",
  //   tenant: [""],
  //   roles: ["admin", "manager"],
  //   permission: null,
  //   feature: null,
  // },
  "oasis-ice-cream.customers": {
    title: "Customers",
    id: "oasis-ice-cream.customers",
    component: (props) => <CustomersTab {...props} />,
    icon: <PeopleIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.drivers": {
    title: "Drivers",
    id: "oasis-ice-cream.drivers",
    component: (props) => <DriversTab {...props} />,
    icon: <DeliveryDiningIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests": {
    title: "Order Requests",
    id: "order_requests",
    component: (props) => <OrdersTab {...props} />,
    icon: <ShoppingCartIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "medals-of-america.magento_orders": {
    title: "Magento Orders",
    id: "magento_orders",
    component: (props) => <MagentoOrdersTab {...props} />,
    icon: <ReceiptLongIcon />,
    app: "magento",
    tenant: ["medals-of-america"],
    roles: [],
    permission: null,
    feature: null,
  },
  rcs_campaign_analytics: {
    id: "rcs_campaign_analytics",
    title: "RCS",
    component: (props) => <RCSAnalyticsTab {...props} />,
    icon: <InsightsIcon />,
    app: "analyticsMenu",
    tenant: [],
    roles: [],
    permission: "rcs_bot_create.view",
    feature: "",
  },
  "oasis-ice-cream.zones": {
    id: "zones",
    title: "Zones",

    component: (props) => <ZonesTab {...props} />,
    icon: <MapIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.zone_assignment": {
    id: "zone_assignment",
    title: "Zone Assignment",
    component: (props) => <ZoneAssignmentsTab {...props} />,
    icon: <TravelExploreIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests_per_drivers": {
    id: "oasis-ice-cream.order_requests_per_drivers",
    title: "Order Requests Per Drivers",
    component: (props) => <DriverOrderReportTab {...props} />,
    icon: <DirectionsCarIcon />,
    app: "reports",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests_per_zone": {
    id: "oasis-ice-cream.order_requests_per_zone",
    title: "Order Requests Per Zone",
    component: (props) => <ZoneOrderReportTab {...props} />,
    icon: <TerrainIcon />,
    app: "reports",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests_per_customers": {
    id: "oasis-ice-cream.order_requests_per_customers",
    title: "Order Requests Per Customers",
    component: (props) => <CustomerOrderReportTab {...props} />,
    icon: <PersonSearchIcon />,
    app: "reports",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests_per_month": {
    id: "oasis-ice-cream.order_requests_per_month",
    title: "Order Requests Per Month",
    component: (props) => <MonthlyPerformanceReportTab {...props} />,
    icon: <DateRangeIcon />,
    app: "reports",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  "oasis-ice-cream.order_requests_per_timeslot": {
    id: "oasis-ice-cream.order_requests_per_timeslot",
    title: "Order Requests Per Timeslot",
    component: (props) => <TimeSlotWiseReportTab {...props} />,
    icon: <ScheduleIcon />,
    app: "reports",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },
  // wa_business_profile: {
  //   id: "wa_business_profile",
  //   title: "WA Business Profile",
  //   component: (props) => <SettingsDashboard {...props} />,
  //   icon: <BusinessIcon />,
  //   app: "bussiness_profile", // Change from "settings" to "bussiness_profile"
  //   tenant: [],
  //   roles: ["admin", "manager", "user"],
  //   permission: "dashboard.view",
  //   feature: null,
  // },
  "oasis-ice-cream.cron": {
    id: "oasis-ice-cream.cron",
    title: "Cron",
    component: (props) => <JobsTab {...props} />,
    icon: <AccessTimeFilledIcon />,
    app: "main",
    tenant: ["oasis-ice-cream"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },

  users_add: {
    title: "Users",
    icon: UsersIcon,
    app: "users",
    component: (props) => <UserFormPage {...props} />,
    id: "users_add",
    tenant: [],
    roles: [],
    permission: "users.add",
    feature: "",
    hidden:true
  },
  conversations: {
    id: "conversations",

    title: "Conversation",
    component: (props) => <ChatDashboard {...props} />,
    icon: <SupportAgentIcon />,
    app: "chat",
    tenant: [],
    roles: [],
    permission: "conversations.view",
    feature: "",
  },
  chat_analytics: {
    id: "chat_analytics",

    title: "Analytics",
    component: (props) => <ChatAnalytics {...props} />,
    icon: <SupportAgentIcon />,
    app: "chat",
    tenant: [],
    roles: [],
    permission: "chat_analytics.view",
    feature: "",
  },
  analytics_whatsapp: {
    id: "analytics_whatsapp",
    title: "WhatsApp",
    component: (props) => <WhatsAppAnalyticsTab {...props} />,
    icon: <SupportAgentIcon />,
    app: "analyticsMenu",
    tenant: [],
    roles: [],
    permission: "user_engagement_overview.view",
    feature: "",
  },

  // In your sideBarData, update these two items:
  marketing_broadcast: {
    id: "marketing_broadcast",
    title: "Broadcast",
    // Old Broadcast page retired: hidden, and existing links to it open Campaigns instead
    component: (props) => <CampaignsV2 {...props} />,
    icon: <CampaignIcon />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "marketing_broadcast.view",
    feature: "",
    hidden: true,
    group: "marketing_broadcast_group", // Add this
  },
  create_marketing_broadcast: {
    id: "create_marketing_broadcast",
    title: "Marketing Broadcast",
    component: (props) => <Broadcast {...props} />,
    icon: <CampaignIcon />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "marketing_broadcast.create",
    feature: "",
    hidden: true,
    group: "marketing_broadcast_group", // Add this (same group)
  },
  campaigns_v2: {
    id: "campaigns_v2",
    title: "Campaigns",
    component: (props) => <CampaignsV2 {...props} />,
    icon: <CampaignIcon />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "marketing_broadcast.view",
    feature: "",
    group: "marketing_broadcast_group",
  },
  campaigns_v2_setup: {
    id: "campaigns_v2_setup",
    title: "Add Broadcast",
    component: (props) => <CampaignSetup {...props} />,
    icon: <CampaignIcon />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "marketing_broadcast.create",
    feature: "",
    hidden: true,
    group: "marketing_broadcast_group",
  },
  audience: {
    id: "audience",

    title: "Broadcast Audience",
    component: (props) => <BroadcastAudienceTab {...props} />,
    icon: <Groups2Icon />,
    app: "customers",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "audience.view",
    feature: "audience",
  },

  customer_leads: {
    id: "customer_leads",
    title: "Leads",
    component: (props) => <CustomerLeads {...props} />,
    icon: <ContactsIcon />,
    app: "customers",
  },

  customer_accounts: {
    id: "customer_accounts",
    title: "Customers",
    component: (props) => <CustomerAccounts {...props} />,
    icon: <BusinessIcon />,
    app: "customers",
  },

  // "19": { title: "WA Billing", component: (props) => <AppUsage {...props} />, icon: <ReceiptLongIcon />, app: "billing", tenant: [], roles: ["admin"], permission: "whatsapp_billing.view", feature: "whatsapp_billing" },

  // "23": { title: "Meta Rate Card", component: (props) => <MetaCard {...props} />, icon: <PaymentIcon />, app: "billing", tenant: [], roles: ["admin"], permission: "meta_rate_card.view", feature: "meta_rate_card" },
  // users: {
  //   title: "Users",
  //   id: "users",

  //   component: (props) => <UsersTab {...props} />,
  //   icon: <ManageAccountsIcon />,
  //   app: "settings",
  //   tenant: [],
  //   roles: ["admin"],
  //   permission: "users.view",
  //   feature: "users",
  // },

  products: {
    title: "Products",
    id: "products",
    component: (props) => <Products {...props} />,
    icon: <InventoryIcon />,
    app: "commerce",
    tenant: [],
    roles: [],
    permission: "commerce_product.view",
    feature: "",
  },
  orders: {
    title: "Orders",
    id: "orders",
    component: (props) => <Orders {...props} />,
    icon: <ShoppingBagIcon />,
    app: "commerce",
    tenant: [],
    roles: [],
    permission: "commerce_order.view",
    feature: "",
  },
  "carepms.my_insights": {
    title: "My Insights",
    id: "carepms.my_insights",
    component: (props) => <RMDashboard {...props} />,
    icon: <InsightsIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "my_dashboard.view",
    feature: null,
  },
  "carepms.client_directory": {
    title: "Client Directory",
    id: "carepms.client_directory",
    component: (props) => <CustomerHomePage {...props} />,
    icon: <ContactsIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "client_details.view",
    feature: null,
  },
  "carepms.portfolio_holdings": {
    title: "Portfolio Holdings",
    id: "carepms.portfolio_holdings",
    component: (props) => <Home {...props} />,
    icon: <CurrencyExchangeIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "holdings.view",
    feature: null,
  },
  client_interactions: {
    title: "Client Interactions",
    id: "client_interactions",
    component: (props) => <ClientDetails {...props} />,
    icon: <ConnectWithoutContactIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "client_details.view",
    feature: null,
  },
  "carepms.rm_performance_tracker": {
    title: "RM Performance Tracker",
    id: "carepms.rm_performance_tracker",
    component: (props) => <RMMetricsDashboard {...props} />,
    icon: <TrackChangesIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin"],
    permission: "rm_metrics.view",
    feature: null,
  },
  "carepms.file_upload": {
    title: "File Upload",
    id: "carepms.file_upload",
    component: (props) => <FileUpload {...props} />,
    icon: <CloudUploadIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin"],
    permission: "upload.add",
    feature: null,
  },
  "carepms.upload_tracker": {
    title: "Upload Tracker",
    id: "carepms.upload_tracker",
    component: (props) => <UploadHistory {...props} />,
    icon: <UploadFileIcon />,
    app: "finance360",
    tenant: ["carepms"],
    roles: ["admin"],
    permission: "upload.view",
    feature: null,
  },
  // "35": { title: "Dashboard", component: (props) => <Dashboard {...props} />, icon: <LeaderboardIcon />, app: "analytics", tenant: [], roles: ["admin", "manager"], permission: "dashboard.view", feature: "dashboard" },
  // "36": { title: "Message By Customer", component: (props) => <CustomerMsgDashboard {...props} />, icon: <QueryStatsIcon />, app: "analytics", tenant: [], roles: ["admin", "manager"], permission: null, feature: null },
  // "37": { title: "Sync Report Data", component: (props) => <SyncKRClientLog {...props} />, icon: <SyncIcon />, app: "analytics", tenant: [], roles: ["admin", "manager"], permission: null, feature: null },
  // chat_history: {
  //   title: "Chat History",
  //   id: "chat_history",
  //   component: (props) => <ChatHistoryDashboard {...props} />,
  //   icon: <HistoryEduIcon />,
  //   app: "live_agent",
  //   tenant: [],
  //   roles: ["admin", "manager"],
  //   permission: "live_agent_basic.view",
  //   feature: "gen_ai_live_agent",
  // },

  // campaign_management: {
  //   title: "Campaign Management",
  //   id: "campaign_management",
  //   component: (props) => <CampaignManagement {...props} />,
  //   icon: <ManageSearchIcon />,
  //   app: "whatsapp_marketing",
  //   tenant: [],
  //   roles: ["admin", "manager"],
  //   permission: "campaigns.view",
  //   feature: "campaigns",
  // },

  // "43": { title: "Tenant Onboading", component: (props) => <TenantOnboardingPage {...props} />, icon: <DomainAddIcon />, app: "analytics", tenant: ["carepms"], roles: ["admin", "manager"], permission: "template_analytics.view", feature: "template_analytics" },
  "carepms.appointment_management": {
    title: "Appointment Management",
    id: "carepms.appointment_management",
    component: (props) => <AppointmentManagement {...props} />,
    icon: <AddHomeWorkRoundedIcon />,
    app: "appointment_system",
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "template_analytics.view",
    feature: null,
  },
  "voice.softphone": {
    title: "Voice Calls",
    id: "voice.softphone",
    component: (props) => <Voice {...props} />,
    icon: <RecordVoiceOverIcon />,
    app: "voice",
    roles: ["admin", "manager", "user"],
    permission: null,
    feature: null,
  },
  // "carepms.conversational_ai": {
  //   title: "Conversational AI",
  //   id: "carepms.conversational_ai",
  //   component: (props) => <ConversationPanel {...props} />,
  //   icon: <AutoAwesomeIcon />,
  //   app: "live_agent",
  //   tenant: ["carepms"],
  //   roles: ["admin", "manager"],
  //   permission: "live_agent_basic.view",
  //   feature: null,
  // },
  // "45": { title: "Invoice Billing", component: (props) => <InvoiceBilling {...props} />, icon: <ReceiptOutlinedIcon />, app: "billing", tenant: [], roles: ["admin"], permission: "meta_rate_card.view", feature: "meta_rate_card" },
  // "46": { title: "Wallet", component: (props) => <MyWallet {...props} />, icon: <AccountBalanceWalletOutlinedIcon />, app: "billing", tenant: [], roles: ["admin"], permission: "meta_rate_card.view", feature: "meta_rate_card" },
  "carepms.all": {
    title: "All",
    id: "carepms.all",
    component: (props) => <IntegrationsOverview {...props} />,
    icon: <IntegrationInstructionsOutlinedIcon />,
    app: "integration",
    tenant: ["carepms"],
    roles: ["admin", "manager", "user"],
    permission: "integration.view",
    feature: "null",
  },
  calendly: {
    title: "Calendly",
    id: "calendly",
    component: (props) => <CalendlyBooking {...props} />,
    icon: <CurrencyRupeeIcon />,
    app: "",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "audience.view",
    feature: "null",
  },
  zoho: {
    title: "Zoho",
    id: "zoho",
    component: (props) => <Zoho {...props} />,
    icon: tenant === "carepms" ? <CurrencyRupeeIcon /> : <PaidIcon />,
    app: "",
    tenant: ["carepms"],
    roles: ["admin", "manager", "user"],
    permission: "audience.view",
    feature: "null",
  },
  insights: {
    id: "insights",
    title: "Insights",
    component: (props) => <DoorLocksTab {...props} />,
    icon: <GridViewIcon />,
    app: "door_solutions",
    tenant: ["dormakabademo"],
    roles: ["admin", "manager"],
    permission: "door_solutions.view",
    feature: null,
  },
  installation: {
    id: "installation",
    title: "Installation",
    component: (props) => <InstallationTab {...props} />,
    icon: <SettingsApplicationsIcon />,
    app: "door_solutions",
    tenant: ["dormakabademo"],
    roles: ["admin", "manager"],
    permission: "door_solutions.view",
    feature: null,
  },
  service: {
    id: "service",
    title: "Service",
    component: (props) => <ServiceTab {...props} />,
    icon: <EnhancedEncryptionIcon />,
    app: "door_solutions",
    tenant: ["dormakabademo"],
    roles: ["admin", "manager"],
    permission: "door_solutions.view",
    feature: null,
  },
  sales: {
    id: "sales",
    title: "Sales",
    component: (props) => <SalesTab {...props} />,
    icon: <ShoppingCartIcon />,
    app: "door_solutions",
    tenant: ["dormakabademo"],
    roles: ["admin", "manager"],
    permission: "door_solutions.view",
    feature: null,
  },

  billing_overview: {
    id: "billing_overview",
    title: "Overview",
    component: (props) => <OverviewTab {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_overview.view",
    feature: "whatsapp_billing",
  },
  billing_usage_and_charges: {
    id: "billing_usage_and_charges",
    title: "Usage & Charges",
    component: (props) => <UsageCharges {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_usage_and_charges.view",
    feature: "whatsapp_billing",
  },
  billing_wallet: {
    id: "billing_wallet",
    title: "Wallet",
    component: (props) => <WalletTab {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_wallet.view",
    feature: "whatsapp_billing",
  },
  billing_rate_card: {
    id: "billing_rate_card",
    title: "Rate Card",
    component: (props) => <MessageRatesDashboard {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_rate_card.view",
    feature: "whatsapp_billing",
  },
  billing_invoices: {
    id: "billing_invoices",
    title: "Invoices",
    component: (props) => <InvoicesTab {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_invoices.view",
    feature: "whatsapp_billing",
  },
  billing_subscription: {
    id: "billing_subscription",
    title: "Subscription",
    component: (props) => <SubscriptionManagement {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_subscription_plan.view",
    feature: "whatsapp_billing",
  },
  billing_settings: {
    id: "billing_settings",
    title: "Billing Settings",
    component: (props) => <SettingsTab {...props} />,
    icon: <AccountBalanceWalletOutlinedIcon />,
    app: "billing",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "billing_settings.view",
    feature: "whatsapp_billing",
  },
  create_segment: {
    id: "create_segment",
    title: "Create Segment",
    component: (props) => <CreateSegment {...props} />,
    icon: <PlaylistAdd />,
    app: "customers",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "segment.create",
    feature: "",
    hidden: true,
    group: "segment_group",
  },
  segments: {
    id: "segments",
    title: "Segments",
    component: (props) => <Segments {...props} />,
    icon: <PieChart />,
    app: "customers",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "segment.view",
    feature: "",
    hidden: true, // Now reached via the "Segment" tab inside Broadcast Audience
    group: "segment_group",
  },
  update_segment: {
    id: "update_segment",
    title: "Update Segment",
    component: (props) => <UpdateSegment {...props} />,
    icon: <Menu />,
    app: "customers",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "segment.edit",
    feature: "audience",
    hidden: true,
    group: "segment_group",
  },
  drip_marketing: {
    id: "drip_marketing",
    title: "Drip Marketing",
    component: (props) => <DripMarketing {...props} />,
    icon: <Timeline />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "drip_marketing.view",
    feature: "",
    group: "drip_marketing_group",
  },

  // Update wa_analytics to be under Campaigns (whatsapp_marketing)
  wa_analytics: {
    title: "WA Analytics",
    icon: WhatsappAnalytics,
    app: "campaigns", // This makes it appear under Campaigns section
    id: "wa_analytics",
    hasChildren: true, // Flag to indicate it has its own children
    group: "wa_analytics_group", // Group for its children
    hidden: true,
  },

  // Update template_analytics to belong to wa_analytics group
  template_analytics: {
    title: "Template Analytics",
    id: "template_analytics",
    component: (props) => <TemplateAnalytics {...props} />,
    icon: <AssessmentIcon />,
    app: "campaigns", // This can stay as analytics since it's a child
    tenant: [],
    roles: ["admin", "manager"],
    permission: "template_analytics.view",
    feature: "template_analytics",
    parent: "wa_analytics", // This makes it a child of wa_analytics
    group: "wa_analytics_group", // Same group
  },

  // Update user_engagement_overview to belong to wa_analytics group
  "carepms.user_engagement_overview": {
    title: "User Engagement Overview",
    id: "carepms.user_engagement_overview",
    component: (props) => <BotbridgeAnalytics {...props} />,
    icon: <MonitorHeartIcon />,
    app: "campaigns", // This can stay as analytics since it's a child
    tenant: ["carepms"],
    roles: ["admin", "manager"],
    permission: "user_engagement_overview.view",
    feature: "user_engagement_overview",
    parent: "wa_analytics", // This makes it a child of wa_analytics
    group: "wa_analytics_group", // Same group
  },
  create_drip_marketing_campaign: {
    id: "create_drip_marketing_campaign",
    title: "Create Drip Marketing Campaign",
    component: (props) => <CreateDripMarketingCampaign {...props} />,
    icon: <Timeline />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "drip_marketing.create",
    feature: "",
    hidden: true,
    group: "drip_marketing_group",
  },
  drip_marketing_campaign_details: {
    id: "drip_marketing_campaign_details",
    title: "Drip Marketing Campaign Details",
    component: (props) => <DripMarketingCampaignDetails {...props} />,
    icon: <Timeline />,
    app: "campaigns",
    tenant: [],
    roles: [],
    permission: "drip_marketing.view",
    feature: "",
    hidden: true,
  },
  upload_csv: {
    id: "upload_csv",
    title: "Kalnirnay Automation",
    component: (props) => <PanchangLayout {...props} />,
    icon: <Menu />,
    app: "kalnirnay",
    tenant: ["kalnirnay"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },

  survey_responses: {
    id: "survey_responses",
    title: "Survey Reports",
    component: (props) => <SurveyResponsesPage {...props} />,
    icon: <Menu />,
    app: "survey_reports",
    tenant: ["yessecurities"],
    roles: ["admin", "manager"],
    permission: null,
    feature: null,
  },

  order_items: {
    id: "order_items",
    title: "Order Items",
    component: (props) => <OrderItemsList {...props} />,
    icon: <ShoppingBagIcon />,
    app: "commerce",
    tenant: [],
    roles: [],
    permission: "commerce_order_items.view",
    feature: "",
    hidden: true,
  },

  buyers: {
    id: "buyers",
    title: "Buyers",
    component: (props) => {
      const currentTenant = localStorage.getItem("tenant");
      return ["kalnirnay"].includes(currentTenant) ? (
        <KalnirnayCustomers {...props} />
      ) : (
        <Buyers {...props} />
      );
    },
    icon: <People />,
    app: "commerce",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "commerce_buyer.view",
    feature: "commerce_order",
  },
  "otm.quiz_dashboard": {
    id: "quiz_dashboard",
    title: "Quiz dashboard",
    component: (props) => <QuizDashboardMUI {...props} />,
    icon: <People />,
    app: "onetouchindiamarketinglive",
    tenant: ["oneTouchIndiaMarketingLive"],
    roles: ["admin", "manager"],
    permission: "quiz.view",
    feature: null,
  },
  "otm.pharmacy_dashboard": {
    id: "pharmacy_dashboard",
    title: "Pharmacy dashboard",
    component: (props) => <PharmacyDashboard {...props} />,
    icon: <People />,
    app: "pharmacy",
    tenant: ["oneTouchIndiaMarketingLive"],
    roles: ["admin", "manager"],
    permission: "quiz.view",
    feature: null,
  },
  // Re-enabled for BB-2764 (per-bot AI model override, knowledge-base re-embed).
  // Was hidden with app "live_agent" and permission "ai_bot.view", which doesn't
  // exist in tenant/constants.py; it now sits with the other Agentic AI pages and
  // uses their permission (ai_based_chatbot add-on). Saving needs agentic_ai.edit.
  ai_bot_configuration: {
    id: "ai_bot_configuration",
    title: "Configuration",
    component: (props) => <AIBotConfiguration {...props} />,
    icon: <Assistant />,
    app: "agentic_ai",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "agentic_ai.view",
    feature: null,
  },
  // ai_bot_report: {
  //   id: "ai_bot_report",
  //   title: "AI Bot Analytics",
  //   component: (props) => <AIBotReport {...props} />,
  //   icon: <Analytics />,
  //   app: "dashboard",
  //   tenant: [],
  //   roles: ["admin", "manager"],
  //   permission: "ai_bot.view",
  //   feature: null,
  // },
  no_access: {
    id: "no_access",
    title: "No Access",
    component: (props) => <NoAccessPage {...props} />,
    icon: <LockIcon />,
    app: "settings",
    tenant: [],
    roles: [],
    permission: null,
    feature: null,
    hidden: true,
  },
  // rcs_management: {
  //   id: "rcs_management",
  //   title: "RCS Management",
  //   component: (props) => <RCSDashboardNew {...props} />,
  //   icon: <CampaignIcon />,
  //   app: "rcs_bot_create",
  //   tenant: [],
  //   roles: ["admin", "manager", "user"],
  //   permission: "rcs_bot_create.view",
  //   feature: null,
  // },
  subscription_management: {
    id: "subscription_management",
    title: "Subscription Management",
    component: (props) => <SubscriptionManagement {...props} />,
    icon: <CampaignIcon />,
    app: "settings",
    tenant: [],
    roles: ["admin", "manager"],
    // permission: "tools.view",
    // feature: "tools",
    permission: null,
    feature: null,
  },

  skills: {
    id: "skills",
    title: "Skills",
    component: (props) => <AgenticAISkills {...props} />,
    icon: <Groups2Icon />,
    app: "agentic_ai",
    tenant: [],
    roles: [],
    permission: "agentic_ai.view",
    feature: "",
    group: "agnetic_ai_skills",
  },
  create_new_agent: {
    id: "create_new_agent",
    title: "Skills",
    component: (props) => <KnowledgeBasePage {...props} />,
    icon: <Groups2Icon />,
    app: "agentic_ai",
    tenant: [],
    roles: [],
    permission: "agentic_ai.create",
    feature: "",
    hidden: true,
    group: "agnetic_ai_skills",
  },
  ai_bot_report: {
    id: "ai_bot_report",
    title: "Analytics",
    component: (props) => <AIBotReport {...props} />,
    icon: <Analytics />,
    app: "agentic_ai",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "ai_bot_report.view",
    feature: null,
  },
  agentic_ai_token_calc: {
    title: "AI Token Calculator",
    id: "agentic_ai_token_calc",
    component: (props) => <AITokenCalculator {...props} />,
    icon: <HandymanIcon />,
    app: "agentic_ai",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "agentic_ai_token_calc.view",
    feature: "tools",
  },
  chatbot_start_point: {
    id: "chatbot_start_point",
    title: "Chatbot Start Point",
    component: (props) => <ChatbotStartPoint {...props} />,
    icon: <ChatBubble />,
    app: "chatbot_configuration",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "chatbot_start_point.view",
    feature: null,
  },

  work_flow: {
    id: "work_flow",
    title: "Workflow",
    component: (props) => <Workflows {...props} />,
    icon: <AccountTree />,
    app: "chatbot_configuration",
    tenant: [],
    roles: ["admin", "manager"],
    group: "work_flow_group",
    permission: "work_flow.view",
    feature: null,
  },

  chatbot_flow: {
    id: "chatbot_flow",
    title: "Workflow",
    component: (props) => {
      return <ChatbotFlow {...props} />;
    },
    icon: <AccountTree />,
    app: "chatbot_configuration",
    tenant: [],
    roles: [],
    permission: "work_flow.view",
    group: "work_flow_group",
    feature: null,
    hidden: true,
  },

  instagram_quick_flow: {
    id: "instagram_quick_flow",
    title: "Instragram Quick Flow",
    //component: (props) => <ChatbotFlow {...props} />,
    icon: <AccountTree />,
    app: "chatbot_configuration",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "instagram_quick_flow.view",
    feature: null,
  },

  // lead_generation: {
  //   id: "lead_generation",
  //   title: "Lead Generation",
  //   component: (props) => <LeadGeneration {...props} />,
  //   icon: <ContactsIcon />,
  //   app: "lead_generation",
  //   tenant: [],
  //   roles: ["admin", "manager", "user"],
  //   permission: "lead_generation.view",
  //   feature: "lead_generation",
  // },
  form_builder: {
    id: "form_builder",
    title: "Form Builder",
    component: (props) => <FormBuilder {...props} />,
    icon: <Assignment />,
    app: "message_template",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "whatsapp_forms.create",
    feature: "",
    hidden: true,
    group: "whatsapp_forms_group",
  },

  form_unmatched_replies: {
    id: "form_unmatched_replies",
    title: "Unmatched Form Replies",
    component: (props) => <UnmatchedReplies {...props} />,
    icon: <Assignment />,
    app: "message_template",
    tenant: [],
    roles: ["admin"],
    permission: "whatsapp_forms.view",
    feature: "",
    hidden: true,
    group: "whatsapp_forms_group",
  },

  form_submissions: {
    id: "form_submissions",
    title: "Form Submissions",
    component: (props) => <FormSubmissions {...props} />,
    icon: <Assignment />,
    app: "message_template",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "whatsapp_forms.view",
    feature: "",
    hidden: true,
    group: "whatsapp_forms_group",
  },

  interactive_list: {
    id: "interactive_list",
    title: "Interative List",
    //component: (props) => <ViewForms {...props} />,
    icon: <Assignment />,
    app: "chatbot_configuration",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "interactive_list.view",
    feature: "whatsapp_template",
  },

  view_templates: {
    id: "view_templates",

    title: "Templates",
    component: (props) => <Whatsapp {...props} />,
    icon: <TemplateIcon />,
    app: "message_template",
    tenant: [],
    roles: [],
    permission: "whatsapp_template.view",
    feature: "",
    group: "whatsapp_template_group", // Add this
  },

  create_templates: {
    id: "create_templates",

    title: "Create Templates",
    component: (props) => <CreateTemplateManual {...props} />,
    icon: <CreateIcon />,
    app: "message_template",
    tenant: [],
    roles: [],
    permission: "whatsapp_template.create",
    feature: "",
    hidden: true,
    group: "whatsapp_template_group",
  },

  "Create Templates Gen AI": {
    title: "Create Templates Gen AI",
    id: "create_templates_gen_ai",

    component: (props) => <ComingSoonPage {...props} />,
    icon: <AutoAwesomeIcon />,
    app: "message_template",
    tenant: [],
    roles: ["admin", "manager", "user"],
    permission: "create_templates_gen_ai.view",
    feature: "campaigns",
  },

  standard_templates: {
    title: "Standard Templates",
    id: "standard_templates",

    component: (props) => <ComingSoonPage {...props} />,
    icon: <ArticleIcon />,
    app: "message_template",
    tenant: [],
    roles: ["admin", "manager"],
    permission: "standard_templates.view",
    feature: null,
  },

  whatsapp_forms: {
    id: "whatsapp_forms",
    title: "Whatsapp Forms",
    component: (props) => <FormsManagement {...props} />,
    icon: <Assignment />,
    app: "message_template",
    tenant: [],
    roles: [],
    permission: "whatsapp_forms.view",
    feature: "",
    group: "whatsapp_forms_group",
  },
  // file_upload_logs: {
  //   title: "File Upload Logs",
  //   id: "file_upload_logs",
  //   component: (props) => <FileUploadLogs {...props} />,
  //   icon: <AttachFileIcon />,
  //   app: "logs",
  //   tenant: [],
  //   roles: ["admin"],
  //   permission: "logs.view",
  //   feature: null,
  // },
  // rcs_broadcast_logs: {
  //   title: "RCS Broadcast Logs",
  //   id: "rcs_broadcast_logs",
  //   component: (props) => <RCSBroadcastLogs {...props} />,
  //   icon: <AttachFileIcon />,
  //   app: "logs",
  //   tenant: [],
  //   roles: ["admin"],
  //   permission: "logs.view",
  //   feature: null,
  // },
  // chat_logs: {
  //   title: "Chat Logs",
  //   id: "chat_logs",
  //   component: (props) => <WhatsAppMessage {...props} />,
  //   icon: <MessageIcon />,
  //   app: "logs",
  //   tenant: [],
  //   roles: [],
  //   permission: "logs.view",
  //   feature: "wa_messages_logs",
  // },
  // broadcast_logs: {
  //   title: "Broadcast Logs",
  //   id: "broadcast_logs",
  //   component: (props) => <MarketingLogsTable {...props} />,
  //   icon: <RecordVoiceOverIcon />,
  //   app: "logs",
  //   tenant: [],
  //   roles: [],
  //   permission: "logs.view",
  //   feature: "template_logs",
  // },
  "climatronics.leads": {
    title: "Leads",
    id: "climatronics.leads",
    component: (props) => <ClimatronicsLeads {...props} />,
    icon: <ContactsIcon />,
    app: "climatronics",
    tenant: [],
    roles: [],
    permission: "climatronics_customers.view",
    feature: null,
  },
  "climatronics.customers": {
    title: "Registrered Customers",
    id: "climatronics.customers",
    component: (props) => <ClimatronicsCustomers {...props} />,
    icon: <ContactsIcon />,
    app: "climatronics",
    tenant: [],
    roles: [],
    permission: "climatronics_customers.view",
    feature: null,
  },
  "climatronics.orders": {
    title: "Shipment Records",
    id: "climatronics.orders",
    component: (props) => <ClimatronicsOrders {...props} />,
    icon: <ShoppingCartIcon/>,
    app: "climatronics",
    tenant: [],
    roles: [],
    permission: "climatronics_orders.view",
    feature: null,
  },
  ctwa: {
    title: "Campaigns",
    id: "ctwa",
    component: (props) => <CTWADashboard {...props} />,
    icon: <LinkIcon/>,
    app: "ctwa",
    tenant: [],
    roles: [],
    permission: "ctwa.view",
    feature: null,
  },
  "ctwa.analytics": {
    title: "Analytics",
    id: "ctwa.analytics",
    component: (props) => <CampaignAnalyticsPage {...props} />,
    icon: <LinkIcon/>,
    app: "ctwa",
    tenant: [],
    roles: [],
    permission: "ctwa.view",
    feature: null,
  },
  "mutual_fund_distributor.dashboard": {
    title: "Dashboard",
    id: "mutual_fund_distributor.dashboard",
    component: (props) => <MutualFundDistributorDashboard {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_dashboard.view",
    feature: null
  },
  "mutual_fund_distributor.leads": {
    title: "Leads",
    id: "mutual_fund_distributor.leads",
    component: (props) => <MutualFundDistributorLeads {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: ["mfd_registered_leads.view", "mfd_leads.view"],
    feature: null
  },
  "mutual_fund_distributor.clients": {
    title: "Clients",
    id: "mutual_fund_distributor.clients",
    component: (props) => <MutualFundDistributorClients {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_clients.view",
    feature: null
  },
  "mutual_fund_distributor.daily_holdings": {
    title: "Daily Holdings",
    id: "mutual_fund_distributor.daily_holdings",
    component: (props) => <MutualFundDistributorDailyHoldings {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_daily_holdings.view",
    feature: null
  },
  "mutual_fund_distributor.report_requests": {
    title: "Requests",
    id: "mutual_fund_distributor.report_requests",
    component: (props) => <MutualFundDistributorRequests {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: ["mfd_report_requests.view", "mfd_advisor_calls.view"],
    feature: null
  },
  "mutual_fund_distributor.goal_planning": {
    title: "Goal Planning",
    id: "mutual_fund_distributor.goal_planning",
    component: (props) => <MutualFundDistributorGoalPlans {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_goal_planning.view",
    feature: null
  },
  "mutual_fund_distributor.file_upload": {
    title: "File Upload",
    id: "mutual_fund_distributor.file_upload",
    component: (props) => <MutualFundDistributorFileUpload {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_file_upload.view",
    feature: null
  },
  "mutual_fund_distributor.file_upload_logs": {
    title: "Upload Tracker",
    id: "mutual_fund_distributor.file_upload_logs",
    component: (props) => <MutualFundDistributorFileUploadLogs {...props} />,
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: "mfd_file_upload_logs.view",
    feature: null
  },
  "mutual_fund_distributor.sip_reminders": {
    title: "SIP Reminders",
    id: "mutual_fund_distributor.sip_reminders",
    component: (props) => <SipTrackingScreen {...props} />,
    icon: withBlackColor(PaidIcon),
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: null,
    feature: null
  },
  "mutual_fund_distributor.insurance_reminders": {
    title: "Insurance Reminders",
    id: "mutual_fund_distributor.insurance_reminders",
    component: (props) => <InsuranceReminderScreen {...props} />,
    icon: withBlackColor(HealthAndSafetyIcon),
    app: "mutual_fund_distributor",
    tenant: [],
    roles: [],
    permission: null,
    feature: null
  },
  "mutual_fund_distributor.emi_reminders": {
    title: "EMI Reminders",
    id: "mutual_fund_distributor.emi_reminders",
    component: (props) => <EMIReminderScreen {...props} />,
    icon: withBlackColor(PaymentsIcon),
    app: "cent_bank",
    tenant: [],
    roles: [],
    permission: null,
    feature: null
  },
  "botbridge.leads": {
    title: "Leads",
    id: "botbridge.leads",
    component: (props) => <BotBridgeLeads {...props} />,
    app: "botbridge",
    tenant: [],
    roles: [],
    permission: "bb_leads.view",
    feature: null,
  },
};
